var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 20.1714V22.0114C41.9975 26.3243 40.601 30.5208 38.0187 33.9751C35.4363 37.4294 31.8066 39.9564 27.6707 41.1792C23.5349 42.4021 19.1145 42.2552 15.0689 40.7606C11.0234 39.266 7.56931 36.5036 5.22192 32.8856C2.87453 29.2675 1.75958 24.9876 2.04335 20.6841C2.32712 16.3806 3.99441 12.2841 6.79656 9.00559C9.5987 5.72708 13.3856 3.44221 17.5924 2.49174C21.7992 1.54127 26.2005 1.97612 30.14 3.73145",
    stroke: "#28C76F",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20.0117L22 26.0117L42 6.01172",
    stroke: "#28C76F",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.defa8db2a16d2065c66abbd03a975907.svg";
export { ForwardRef as ReactComponent };